import axios from 'axios'
import axiosRetry from 'axios-retry'

const myAxios = axios.create({
  withCredentials: true,
  baseURL: import.meta.env.VITE_BASE_URL,
})
axiosRetry(myAxios, {
  retries: 3, // Number of retries
  retryDelay: retryCount => {
    return Math.pow(2, retryCount) * 2000
  },
  // retryCondition: error => {
  //   // Only retry if it's a network error or a 5xx status code
  //   // AND NOT a 401 Unauthorized error
  //   return (
  //     (axiosRetry.isNetworkError(error) ||
  //       (error.response &&
  //         error.response.status >= 500 &&
  //         error.response.status <= 599)) &&
  //     error.response?.status !== 401
  //   )
  // },
  // attach callback to each retry to handle logging or tracking
  onRetry: err => console.log(`Retrying request: ${err.message}`),
  // Specify conditions to retry on, this is the default
  // which will retry on network errors or idempotent requests (5xx)
  retryCondition: error => {
    const status = error.response?.status
    // Retry only if status is NOT 401 and it meets the default retry condition
    return (
      ![401, 403].includes(status) &&
      axiosRetry.isNetworkOrIdempotentRequestError(error)
    )
  },
})

myAxios.interceptors.response.use(
  function (response) {
    return response
  },
  async function (error) {
    console.error(error)
    return Promise.reject(error)
  }
)
// Add a request interceptor
myAxios.interceptors.request.use(function (config) {
  if (isSameOrigin(config.url)) {
    const token = window.sessionStorage.getItem('user')
    if (token) {
      config.headers['x-auth'] = token
    }
  }
  return config
})

// Function to check if the URL is of the same origin
function isSameOrigin(url) {
  //check if url start with /
  if (url.startsWith('/')) {
    return true
  }
  return false
}

export default myAxios
